export const TimelineMarkerType = {
  Today: 'Today',
  Custom: 'Custom',
  Cursor: 'Cursor'
}
